import * as t from 'io-ts';
import {isNull} from 'lodash';

import {makeApiType} from './apiTypes';

/*
 * Runtime types.
 */

// Note: this type is incomplete; it has only what we need for where we use it.
const RConversationUpdatedThinEventDirty = t.intersection([
  t.type({
    conversationId: t.number,
  }),
  t.partial({
    isNewlyVisible: t.boolean,
    trackerTeammateIds: t.readonlyArray(t.number),
    tagIds: t.readonlyArray(t.number),
    inboxIds: t.readonlyArray(t.number),
    // null if the conversation is unassigned, undefined if the assignee is unknown.
    assigneeId: t.union([t.number, t.null]),
  }),
]);

/*
 * Types.
 */

export type ConversationUpdatedThinEvent = t.TypeOf<typeof RConversationUpdatedThinEventDirty>;

/*
 * IO methods.
 */

function parseConversationUpdatedThinEvent(src: any): ConversationUpdatedThinEvent {
  return {
    conversationId: src.id,
    isNewlyVisible: src.is_newly_visible,
    trackerTeammateIds: src.tracker_teammate_ids,
    tagIds: src.tag_ids,
    inboxIds: src.inbox_ids,
    assigneeId: src.assignee_id,
  };
}

/*
 * API types.
 */

export const ApiConversationUpdatedThinEvent = makeApiType(
  'conversationUpdatedThinEvent',
  RConversationUpdatedThinEventDirty,
  parseConversationUpdatedThinEvent,
);

/*
 * Helpers.
 */

type MaybeAssignedConversationUpdatedThinEvent = ConversationUpdatedThinEvent & {
  assigneeId: number | undefined;
};

export function isConversationUpdatedThinEventMaybeAssigned(
  event: ConversationUpdatedThinEvent,
): event is MaybeAssignedConversationUpdatedThinEvent {
  return !isNull(event.assigneeId);
}
